import { removeCounty } from '@src/utils';
import { pickMeta, WeekBucketMeta } from './weekBuckets';

export const REPORT_CHART_FONT = {
  family: 'Arial',
  size: 14,
  weight: 400,
} as const;

export const REPORT_CHART_TEXT_STYLE = {
  fontFamily: 'Arial, sans-serif',
  fontSize: 14,
  fontWeight: 400,
} as const;

export const REPORT_METRIC_TITLE_STYLE = {
  color: '#fff',
  fontFamily: 'Arial, sans-serif',
  fontSize: '12px',
  lineHeight: '20px',
  fontWeight: 400,
} as const;

export const REPORT_METRIC_VALUE_STYLE = {
  color: '#fff',
  fontFamily: 'Arial, sans-serif',
  fontSize: '20px',
  lineHeight: '30px',
  fontWeight: 600,
} as const;

export const incompleteChartLabels = ['driver no show', 'member no show'];

export const buildCountyCostChart = (data: any[]) => {
  const labelOf = (el: any) => removeCounty(el.label as string);

  const newLabels: string[] = [];
  const bucketByLabel = new Map<string, WeekBucketMeta | undefined>();
  data?.forEach((item) =>
    Object.values(item ?? {}).forEach((values: any) =>
      (Array.isArray(values) ? values : []).forEach((el) => {
        const label = labelOf(el);
        if (!newLabels.includes(label)) newLabels.push(label);
        if (!bucketByLabel.has(label)) bucketByLabel.set(label, pickMeta(el));
      })
    )
  );

  const hasWeeks = [...bucketByLabel.values()].some(Boolean);
  const newDatasets = data?.flatMap(
    (item) =>
      Object.entries(item).map(([key, values]: [string, any], index) => {
        if (key === 'Unknown')
          return { label: '', data: [], borderColor: 'green' };
        if (!hasWeeks) {
          return {
            label: key,
            data: values?.map((el: any) => el.cost) ?? [],
            borderColor: assetColorByIndex(index),
          };
        }
        // Week buckets: align points to the shared label axis so partial
        // weeks and counties with missing weeks don't shift.
        const byLabel = new Map<string, number>(
          (values ?? []).map((el: any) => [labelOf(el), el.cost])
        );
        return {
          label: key,
          data: newLabels.map((l) => byLabel.get(l) ?? null),
          borderColor: assetColorByIndex(index),
        };
      }) ?? []
  );

  return {
    labels: newLabels,
    datasets: newDatasets ?? [],
    buckets: newLabels.map((l) => bucketByLabel.get(l)),
  };
};
const GOLDEN_ANGLE = 137.508;

export function assetColorByIndex(index: number): string {
  const hue = (index * GOLDEN_ANGLE) % 360;

  const saturation = 40;
  const lightness = 50;

  return `hsl(${hue.toFixed(1)}, ${saturation}%, ${lightness}%)`;
}
